import { Descriptions } from 'antd';
import { popup_props_transaltion } from '../../dictionaries/popup_props_translation.js';
import { addSeparators } from '../../utils/format-utils.js';

function TradeTurnover({ data }) {
  const formatData = () => {
    return ['export_mln_usd', 'import_mln_usd', 'total_mln_usd'].map((item) => {
      return {
        key: item,
        label: popup_props_transaltion[item],
        children: addSeparators(data[item] / 1000000),
      };
    });
  };

  return (
    <Descriptions
      items={formatData()}
      column={1}
      size="small"
      layout="vertical"
    />
  );
}

export default TradeTurnover;
